import React, { useEffect, useRef, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import "./Hourglass.css";

const FIFTEEN_MINUTES = 15 * 60;

const Hourglass: React.FC = () => {
    const [seconds, setSeconds] = useState(FIFTEEN_MINUTES);

    const wrapperRef = useRef<HTMLDivElement | null>(null);
    const flipCardsRef = useRef<NodeListOf<Element>>();

    // 🔥 Auto Date (+3 Days)
    const futureDate = new Date();
    futureDate.setDate(futureDate.getDate() + 3);

    const formattedDate = futureDate.toLocaleDateString("en-GB", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
    });

    /* TIMER */
    useEffect(() => {
        const interval = setInterval(() => {
            setSeconds((prev) => (prev <= 1 ? FIFTEEN_MINUTES : prev - 1));
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    /* SCOPED FLIP CONTROL */
    useEffect(() => {
        if (!wrapperRef.current) return;

        flipCardsRef.current =
            wrapperRef.current.querySelectorAll(".flip-card");

        if (!flipCardsRef.current) return;

        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;

        flipCardsRef.current[0]?.setAttribute(
            "style",
            `--minutes:${minutes}`
        );

        flipCardsRef.current[1]?.setAttribute(
            "style",
            `--seconds:${secs}`
        );

        startAnimation(1);
        if (secs === 59) startAnimation(0);
    }, [seconds]);

    function startAnimation(n: number) {
        if (!flipCardsRef.current) return;

        const flip = flipCardsRef.current[n]?.querySelectorAll("[data-flip]");
        if (!flip) return;

        const top = flip[0] as HTMLElement;
        const bottom = flip[1] as HTMLElement;

        top.dataset.flip = "true";
        bottom.dataset.flip = "true";

        top.addEventListener(
            "animationend",
            () => {
                bottom.addEventListener(
                    "animationend",
                    () => {
                        top.dataset.flip = "false";
                        bottom.dataset.flip = "false";
                    },
                    { once: true }
                );
            },
            { once: true }
        );
    }

    return (
        <Box ref={wrapperRef} sx={{  py: 10, px: 6 }}>
            <Grid container alignItems="center">

                {/* LEFT SIDE CONTENT */}
                <Grid item xs={12} md={7}>
                    <Box>

                        {/* STARTS ON + DATE */}
                        <Box sx={{ mb: 2 }}>
                            <Box
                                component="span"
                                sx={{
                                    color: "#fff",
                                    fontSize: 22,
                                    fontWeight: 700,
                                    letterSpacing: 2,
                                    mr: 1,
                                }}
                            >
                                STARTS ON
                            </Box>

                            <Typography
                                variant="h3"
                                sx={{
                                    background:
                                        "linear-gradient(90deg, #ffffff 0%, #d4af37 100%)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                    position: "relative",
                                    display: "inline-block",
                                    fontWeight: 700,

                                    "&::after": {
                                        content: '""',
                                        position: "absolute",
                                        bottom: "0px",
                                        left: 0,
                                        width: "100%",
                                        height: "10px",
                                        background: "rgb(177 177 177 / 50%)",
                                        //   zIndex: -1,
                                        borderRadius: "4px",
                                    },
                                }}
                            >
                                {formattedDate}
                            </Typography>
                        </Box>

                        {/* TIME */}
                        <Box
                            sx={{
                                color: "#ccc",
                                fontSize: 18,
                                mb: 1,
                            }}
                        >
                            (11:00 AM - 1:00 PM IST)
                        </Box>

                        {/* LANGUAGE */}
                        <Box
                            sx={{
                                color: "#0f63a5",
                                fontSize: 16,
                                fontWeight: 500,
                            }}
                        >
                            Language - Basic English
                        </Box>

                    </Box>
                </Grid>

                <Grid
                    item
                    xs={12}
                    md={5}
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >
                        {/* REGISTER TEXT */}
                        <Typography
                            variant="h5"
                            sx={{
                                color: "#ffffff",
                                mb: 3,
                                textAlign: "center",
                                fontWeight: 600,
                                letterSpacing: 1,
                            }}
                        >
                            Register in next
                        </Typography>

                        {/* COUNTDOWN CARDS */}
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "18px",
                            }}
                        >
                            {/* MINUTES */}
                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <Box className="flip-card">
                                    <span className="top" data-flip="false"></span>
                                    <span className="bottom" data-flip="false"></span>
                                </Box>
                                <Box className="card-title" sx={{color:'white',mt:3}}>Minutes</Box>
                            </Box>

                            {/* SECONDS */}
                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <Box className="flip-card">
                                    <span className="top" data-flip="false"></span>
                                    <span className="bottom" data-flip="false"></span>
                                </Box>
                                <Box className="card-title" sx={{color:'white',mt:3}}>Seconds</Box>
                            </Box>
                        </Box>
                    </Box>
                </Grid>

            </Grid>
        </Box >
    );
};

export default Hourglass;